import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisabledCondition from "../../../../../service/getDisabledCondition"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"

import 黒 from "../../../../img/color/black.png"
import 橙 from "../../../../img/color/orange.png"
import 白 from "../../../../img/color/white.png"

const カバーレイ色 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { coverLayColor: shouldShow } = getDisplayCondition(values)
  const disabled = getDisabledCondition(values)

  return (
    <OneClickField isShow={shouldShow} disabled={disabled.coverLayColor} legend="カバーレイ色">
      <RadioGroup
        name={FIELD_NAMES.カバーレイ色}
        selectedValue={values.coverLayColor}
        onChange={handlers.radio}
        disabled={disabled.coverLayColor}
      >
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT.カバーレイ色.標準色.value} prefixImageSrc={橙}>
            標準色
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.カバーレイ色.白色.value} prefixImageSrc={白}>
            白色
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.カバーレイ色.黒色.value} prefixImageSrc={黒}>
            黒色
          </Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.coverLayColor} />
    </OneClickField>
  )
}

export default カバーレイ色
